module.exports = __webpack_public_path__ + "img/01_abe_04.bb3b27c1.jpg";